// extracted by mini-css-extract-plugin
export default {"container":"ConfirmInvoice_container__UaxTT","contents":"ConfirmInvoice_contents__hJ8tv"};